module.exports = __webpack_public_path__ + "static/media/1.Water tanks.4f91053a.png";